/**
 * @generated SignedSource<<76f71cdb52519eb8ed8c9a3652b89f44>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudProvider = "AWS" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type UpdatePolicyCollectionInput = {
  autoUpdate?: boolean | null | undefined;
  description?: string | null | undefined;
  name?: string | null | undefined;
  provider?: CloudProvider | null | undefined;
  repositoryView?: RepositoryViewInput | null | undefined;
  uuid: string;
};
export type RepositoryViewInput = {
  branchName?: string | null | undefined;
  policyDirectories?: ReadonlyArray<string> | null | undefined;
  policyFileSuffix?: ReadonlyArray<string> | null | undefined;
};
export type UpsertPolicyCollectionMappingsInput = {
  mappings?: ReadonlyArray<PolicyCollectionMappingInput> | null | undefined;
};
export type PolicyCollectionMappingInput = {
  collectionUUID: string;
  policyUUID: string;
  policyVersion: number;
};
export type RemovePolicyCollectionMappingsInput = {
  ids: ReadonlyArray<string>;
};
export type EditPolicyCollectionMutation$variables = {
  connections: ReadonlyArray<string>;
  input: UpdatePolicyCollectionInput;
  removeMappingsInput: RemovePolicyCollectionMappingsInput;
  updateMappingsInput: UpsertPolicyCollectionMappingsInput;
};
export type EditPolicyCollectionMutation$data = {
  readonly removePolicyCollectionMappings: {
    readonly removed: ReadonlyArray<{
      readonly id: string;
    }>;
  };
  readonly updatePolicyCollection: {
    readonly collection: {
      readonly autoUpdate: boolean;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly repositoryView: {
        readonly branchName: string | null | undefined;
        readonly id: string;
        readonly policyDirectories: ReadonlyArray<string> | null | undefined;
        readonly policyFileSuffix: ReadonlyArray<string> | null | undefined;
        readonly uuid: any;
      } | null | undefined;
      readonly uuid: any;
    } | null | undefined;
  } | null | undefined;
  readonly upsertPolicyCollectionMappings: {
    readonly mappings: ReadonlyArray<{
      readonly policy: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
};
export type EditPolicyCollectionMutation = {
  response: EditPolicyCollectionMutation$data;
  variables: EditPolicyCollectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "removeMappingsInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "updateMappingsInput"
},
v4 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "removeMappingsInput"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "input"
    }
  ],
  "concreteType": "PolicyCollectionPayload",
  "kind": "LinkedField",
  "name": "updatePolicyCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PolicyCollection",
      "kind": "LinkedField",
      "name": "collection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "autoUpdate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        (v5/*:: as any*/),
        (v6/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RepositoryView",
          "kind": "LinkedField",
          "name": "repositoryView",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "branchName",
              "storageKey": null
            },
            (v5/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "policyDirectories",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "policyFileSuffix",
              "storageKey": null
            },
            (v7/*:: as any*/)
          ],
          "storageKey": null
        },
        (v7/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "updateMappingsInput"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Policy",
  "kind": "LinkedField",
  "name": "policy",
  "plural": false,
  "selections": [
    (v5/*:: as any*/),
    (v6/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPolicyCollectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": "RemovePolicyCollectionMappingsPayload",
        "kind": "LinkedField",
        "name": "removePolicyCollectionMappings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": true,
            "selections": [
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v8/*:: as any*/),
      {
        "alias": null,
        "args": (v9/*:: as any*/),
        "concreteType": "UpsertPolicyCollectionMappingsPayload",
        "kind": "LinkedField",
        "name": "upsertPolicyCollectionMappings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollectionMapping",
            "kind": "LinkedField",
            "name": "mappings",
            "plural": true,
            "selections": [
              (v10/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v3/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "EditPolicyCollectionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": "RemovePolicyCollectionMappingsPayload",
        "kind": "LinkedField",
        "name": "removePolicyCollectionMappings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v8/*:: as any*/),
      {
        "alias": null,
        "args": (v9/*:: as any*/),
        "concreteType": "UpsertPolicyCollectionMappingsPayload",
        "kind": "LinkedField",
        "name": "upsertPolicyCollectionMappings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PolicyCollectionMapping",
            "kind": "LinkedField",
            "name": "mappings",
            "plural": true,
            "selections": [
              (v10/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "mappings",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "PolicyCollectionMappingEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "260f4e4ff8be33c1a0c0b953247900eb",
    "id": null,
    "metadata": {},
    "name": "EditPolicyCollectionMutation",
    "operationKind": "mutation",
    "text": "mutation EditPolicyCollectionMutation(\n  $input: UpdatePolicyCollectionInput!\n  $updateMappingsInput: UpsertPolicyCollectionMappingsInput!\n  $removeMappingsInput: RemovePolicyCollectionMappingsInput!\n) {\n  removePolicyCollectionMappings(input: $removeMappingsInput) {\n    removed {\n      id\n    }\n  }\n  updatePolicyCollection(input: $input) {\n    collection {\n      autoUpdate\n      description\n      id\n      name\n      repositoryView {\n        branchName\n        id\n        policyDirectories\n        policyFileSuffix\n        uuid\n      }\n      uuid\n    }\n  }\n  upsertPolicyCollectionMappings(input: $updateMappingsInput) {\n    mappings {\n      policy {\n        id\n        name\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5fd808152cbb2501604e3d70039c7802";

export default node;
